import { render, staticRenderFns } from "./r-smart-offer-bundle-plinko-shop-simple.vue?vue&type=template&id=4d031852"
import script from "./r-smart-offer-bundle-plinko-shop-simple.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-plinko-shop-simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d031852')) {
      api.createRecord('4d031852', component.options)
    } else {
      api.reload('4d031852', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-plinko-shop-simple.vue?vue&type=template&id=4d031852", function () {
      api.rerender('4d031852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-plinko-shop/r-smart-offer-bundle-plinko-shop-simple.vue"
export default component.exports